module.exports = __webpack_public_path__ + "static/media/smores.b976c45c.png";